export const ENTITIES = 'ENTITIES'
export const FEATURED_SYMBOLS = 'FEATURED_SYMBOLS'
export const ORDERBOOK = 'ORDERBOOK'
export const AGGTRADES = 'AGGTRADES'
export const USER_AUTH = 'USER_AUTH'
export const ORDERS = 'ORDERS'
export const ORDER_UPDATE = 'ORDER_UPDATE'
export const ORDER_HISTORY_LOADED_ALL = 'ORDER_HISTORY_LOADED_ALL'
export const TRADE_HISTORY_LOADED_ALL = 'TRADE_HISTORY_LOADED_ALL'
export const TRANSACTION_HISTORY_LOADED_ALL = 'TRANSACTION_HISTORY_LOADED_ALL'
export const USER_INFO = 'USER_INFO'
export const ORDER_PRICE = 'ORDER_PRICE'
export const ORDER_QTY = 'ORDER_QTY'
export const ORDER_STOP_PRICE = 'ORDER_STOP_PRICE'
export const ORDER_TRADE_STATUS = 'ORDER_TRADE_STATUS'
export const RESET_ORDER_FORM = 'RESET_ORDER_FORM'
export const TRADE_TIME_IN_FORCE = 'TRADE_TIME_IN_FORCE'
export const TRADE_LIMIT_TYPE = 'TRADE_LIMIT_TYPE'
export const TRADE_REDUCE_ONLY = 'TRADE_REDUCE_ONLY'
export const SWITCH_DIALOG = 'SWITCH_DIALOG'
export const OPEN_ACCOUNT = 'OPEN_ACCOUNT'
export const FEE = 'FEE'
export const SCALE = 'SCALE'
export const FUNDING_FEE = 'FUNDING_FEE'
export const INSURANCE_FUND = 'INSURANCE_FUND'

export function action (type, payload = {}) {
  return {type, ...payload}
}

export const entities = response => action(ENTITIES, {response})
export const featuredSymbols = response => action(FEATURED_SYMBOLS, {response})
export const orderbook = (symbol, response, isFull) => action(ORDERBOOK, {symbol, response, isFull})
export const aggTrades = (symbol, response) => action(AGGTRADES, {symbol, response})
export const switchDialog = dialog => action(SWITCH_DIALOG, {response: {dialog}})

// user
export const orders = response => action(ORDERS, {response})
export const orderUpdate = response => action(ORDER_UPDATE, {response})
export const orderHistoryLoadedAll = (loaded = false) =>
  action(ORDER_HISTORY_LOADED_ALL, {response: loaded})
export const tradeHistoryLoadedAll = (loaded = false) =>
  action(TRADE_HISTORY_LOADED_ALL, {response: loaded})
export const transactionHistoryLoadedAll = (loaded = false) =>
  action(TRANSACTION_HISTORY_LOADED_ALL, {response: loaded})

// auth
export const auth = response => action(USER_AUTH, {response})
export const userInfo = response => action(USER_INFO, {response})

// orderform
export const updateOrderPrice = (buyOrSell, price, formType) =>
  action(ORDER_PRICE, {buyOrSell, price, formType})
export const updateOrderQty = (buyOrSell, orderQty, formType) =>
  action(ORDER_QTY, {buyOrSell, orderQty, formType})
export const updateOrderStopPrice = (buyOrSell, stopPrice, formType) =>
  action(ORDER_STOP_PRICE, {buyOrSell, stopPrice, formType})
export const updateOrderTradeStatus = (buyOrSell, tradeStatus, formType) =>
  action(ORDER_TRADE_STATUS, {buyOrSell, tradeStatus, formType})
export const resetOrderForm = (buyOrSell, formType) =>
  action(RESET_ORDER_FORM, {buyOrSell, formType})
export const updateTimeInForce = (formType, timeInForce) =>
  action(TRADE_TIME_IN_FORCE, {formType, timeInForce})
export const updateLimitType = (formType, limitType) =>
  action(TRADE_LIMIT_TYPE, {formType, limitType})
export const updateReduceOnly = (formType, reduceOnly) =>
  action(TRADE_REDUCE_ONLY, {formType, reduceOnly})

// open future account
export const openAccount = response => action(OPEN_ACCOUNT, {response})

// fee Tier and Rate
export const fee = response => action(FEE, {response})
export const scale = s => action(SCALE, {scale: s})

export const fundingFee = response => action(FUNDING_FEE, {response})
export const insuranceFund = response => action(INSURANCE_FUND, {response})
